import React from 'react'
//import axios from 'axios'
import Suggestions from './../components/UI/Suggestions'

import Logo from '../assets/logo.png';
import {NavLink} from "react-router-dom";


const SearchForm = (props) => {
    return (
        <div className="container col-12 mt-8">
            <form className="form-signin spacer">
                <img className="mx-auto d-block mb-4" src={Logo} alt="logo" width="300"/>
                <h3 className="text-center text-secondary mb-3">Editar questionários</h3>
                <label htmlFor="inputCode" className="sr-only">e.código</label>
                <input
                    type="text" id="inputCode" className="form-control mb-3 mt-4" style={{padding: "10px"}}
                    placeholder="Procurar e.código"

                    onChange={props.editChange}
                />
                { <Suggestions results={props.suggestions}/>}
            </form>
        </div>

    )
};

export default SearchForm;



// WEBPACK FOOTER //
// ./src/components/searchForm.js